import { createContainer } from 'unstated-next';
import useStateObject from '~/react-hooks/use-state-object';
import { DisplayOrder } from '../Containers/Sidebar/Components/Sections/Select';
import { PublishableType } from '~/types/models/publishable';
import { PublishableEmbedControlProps, PublishableEmbedStyleProps } from '@vimily/bonjoro-ui-components-v2/PublishableEmbed';

export interface PublishEditorState
  extends PublishableEmbedControlProps,
    PublishableEmbedStyleProps {
  tag?: string;
  type?: PublishableType;
  displayOrder?: DisplayOrder;
  order?: string[];
}

function useEditorState(initialState?: Partial<PublishEditorState>) {
  return useStateObject(initialState);
}

const PublishState = createContainer(useEditorState);

export const usePublishEditorState = PublishState.useContainer;

export default PublishState;
